import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import './LoadingPanel.scss';

const withStoreData = (Component, { entities, ...options }) => {
  const entityNames = entities.map(e => (typeof e === 'string' ? e : e.name));
  class DataComponent extends React.Component {
    static propTypes = {
      store: PropTypes.shape({
        subscribe: PropTypes.func,
        unsubscribe: PropTypes.func,
        updateState: PropTypes.func,
        update: PropTypes.func,
        loadPage: PropTypes.func,
      }).isRequired,
    };

    static getDerivedStateFromProps(props, state) {
      const newState = props.store.updateState(state, state.subscription, props);
      return newState;
    }

    constructor(props) {
      super(props);

      const { store } = props;
      this.state = {
        subscription: store.subscribe(
          entities,
          (newState) => {
            this.setState(newState);
          },
          options,
          props,
        ),
      };
      this.customProps = {};
      if (options.onUpdateStore) {
        this.customProps[options.onUpdateStore] = this.onUpdateStore.bind(this);
      }
      const makeLoadDataPage = (entityName) => {
        return (page) => {
          return store.loadPage(page, entityName);
        };
      };
      entities.filter(e => ((typeof e !== 'string') && e.onLoadDataPage)).forEach((e) => {
        this.customProps[e.onLoadDataPage] = makeLoadDataPage(e.name);
      });
    }

    componentWillUnmount() {
      this.props.store.unsubscribe(this.state.subscription);
      this.entitiesToLoad = undefined;
      this.unmounted = true;
    }

    onUpdateStore(e) {
      (e ? [e] : this.state.subscription.getRootEntities()).forEach((en) => {
        this.props.store.update(en);
      });
      this.forceUpdate();
    }

    render() {
      const { loading, pendingChanges, subscription, ...dataByEntities } = this.state;
      if (loading) {
        const renderedLoading = {};
        return (
          <div className="grb-loading-panel">
            {/* Only show loading progress for entities not loaded yet */}
            {entityNames.filter(name => !pendingChanges || !pendingChanges[name])
              .map((name) => {
                /* Show loading progress for main entities only */
                return subscription.getParentEntity(name) || name;
              })
              .filter((name) => {
                // Remove main entity duplicates
                // Can happen if loading two derived entities with same parent entity
                if (renderedLoading[name]) return false; // Loading entity already rendered
                renderedLoading[name] = true;
                return true;
              })
              .map((name) => {
                const title = subscription.getRootEntityTitle(name);
                return (
                  <div key={name}>
                    <Typography variant="h6">{`Loading ${title}...`}</Typography>
                    <div className="grb-progress-ctnr">
                      <LinearProgress />
                    </div>
                  </div>
                );
              })}
          </div>
        );
      }
      const props = {
        ...this.props,
        ...dataByEntities,
        ...this.customProps,
      };
      return (
        <Component {...props} />
      );
    }
  }
  return DataComponent;
};

export default withStoreData;
